import Tab from "@mui/material/Tab";
import React from "react";

interface LinkTabProps {
	href: string;
	label?: React.ReactNode;
	value?: unknown;
	icon?: React.ReactElement;
	iconPosition?: "start" | "end" | "top" | "bottom";
	disabled?: boolean;
	"aria-label"?: string;
	"data-component"?: string;
	"data-name"?: string;
}

/**
 * MUI Tab wrapper that renders as an <a> element, enabling middle-click
 * and ctrl/cmd+click to open in a new browser tab. Regular left-clicks
 * are intercepted so MUI's onChange handles tab switching without navigation.
 */
const LinkTab = React.forwardRef<HTMLAnchorElement, LinkTabProps>(function LinkTab(
	{ href, ...rest },
	ref
) {
	return (
		<Tab
			ref={ref}
			component="a"
			href={href}
			onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
				if (
					!event.ctrlKey &&
					!event.metaKey &&
					!event.shiftKey &&
					event.button === 0
				) {
					event.preventDefault();
				}
			}}
			{...rest}
		/>
	);
});

export default LinkTab;
